import { ApiPath } from 'src/enums/apiPath';
import { apiRequest } from 'src/utils/api';

export const getAgencyAuthorityList = async (params: any) => {
  const res = await apiRequest.get({
    url: ApiPath.ADMIN_AGENCY_AUTHORITY,
    params: params
  });
  return res?.data;
};

export const getAgencyAuthorityDetail = async (id?: string) => {
  const res = await apiRequest.get({
    url: `${ApiPath.ADMIN_AGENCY_AUTHORITY}/${id}/detail`
  });
  return res.data;
};

export const getAgencyAuthorityEdit = async (id?: string) => {
  const res = await apiRequest.get({
    url: `${ApiPath.ADMIN_AGENCY_AUTHORITY}/${id}/edit`
  });
  return res.data;
};

export const updateAgencyAuthority = async (
  data: any,
  id?: string | number
) => {
  if (!id) return;
  const res = await apiRequest.put({
    url: `${ApiPath.ADMIN_AGENCY_AUTHORITY}/${id}`,
    data
  });
  return res.data;
};

export const approveAgencyAuthority = async (id?: string | number) => {
  if (!id) return;
  const res = await apiRequest.put({
    url: `/api/admin/agencies/${id}/approved`
  });
  return res.data;
};

export const getUnapprovedAgencyCount = async () => {
  const res = await apiRequest.get({
    url: '/api/admin/agencies/count-unapproved'
  });
  return res.data;
};
